module.exports = __webpack_public_path__ + "img/guandao.95f1641b.png";